module.exports = __webpack_public_path__ + "img/CM-SL-24-Nissan-Lifestyle.6a9f7f9d.jpg";